import type { WordPackDefinition } from "./types";

// Pop Culture pack - entertainment, media, archetypes
export const POP_CULTURE_WORDS = [
  // Music
  "GUITAR", "DRUMS", "BASS", "VINYL", "ALBUM", "CONCERT", "TOUR", "STAGE", "ENCORE", "ANTHEM",
  "BALLAD", "REMIX", "TEMPO", "RHYTHM", "MELODY", "CHORUS", "VERSE", "LYRIC", "DUET", "SOLO",
  "DJ", "MICROPHONE", "SPEAKER", "HEADPHONES", "AMPLIFIER", "SYNTHESIZER", "JUKEBOX", "KARAOKE", "GRAMMY", "PLATINUM",
  // Film & TV
  "DIRECTOR", "ACTOR", "SCENE", "SCRIPT", "SEQUEL", "PREQUEL", "TRAILER", "PREMIERE", "BLOCKBUSTER", "INDIE",
  "DOCUMENTARY", "ANIMATION", "HORROR", "COMEDY", "DRAMA", "THRILLER", "WESTERN", "MUSICAL", "SITCOM", "SOAP",
  "EMMY", "OSCAR", "POPCORN", "CREDITS", "CAMEO", "STUNT", "MONTAGE", "FLASHBACK", "CLIFFHANGER", "TWIST",
  // Characters & Archetypes
  "HERO", "VILLAIN", "SIDEKICK", "MENTOR", "REBEL", "OUTLAW", "DETECTIVE", "SHERIFF", "COWBOY", "SAMURAI",
  "WIZARD", "WARRIOR", "ARCHER", "ASSASSIN", "GLADIATOR", "CHAMPION", "LEGEND", "ICON", "IDOL", "DIVA",
  "PRODIGY", "GENIUS", "MASTERMIND", "MAVERICK", "ROOKIE", "VETERAN", "UNDERDOG", "RIVAL", "NEMESIS", "ALLY",
  // Gaming
  "CONSOLE", "CONTROLLER", "JOYSTICK", "ARCADE", "PIXEL", "AVATAR", "QUEST", "BOSS", "LEVEL", "CHECKPOINT",
  "RESPAWN", "LOOT", "INVENTORY", "COMBO", "MULTIPLAYER", "SPEEDRUN", "GLITCH", "MOD", "PATCH", "DLC",
  // Internet & Social
  "MEME", "VIRAL", "TRENDING", "HASHTAG", "SELFIE", "STREAM", "PODCAST", "VLOG", "INFLUENCER", "FOLLOWER",
  "LIKE", "SHARE", "COMMENT", "SUBSCRIBE", "NOTIFICATION", "FEED", "PROFILE", "HANDLE", "TROLL", "BOT",
  // Fashion & Style
  "RUNWAY", "MODEL", "DESIGNER", "VINTAGE", "RETRO", "HIPSTER", "PUNK", "GRUNGE", "GOTH", "PREPPY",
  "DENIM", "LEATHER", "SNEAKER", "HOODIE", "SUNGLASSES", "TATTOO", "PIERCING", "MAKEUP", "HAIRSTYLE", "ACCESSORY",
  // Events & Celebrations
  "FESTIVAL", "CARNIVAL", "PARADE", "RAVE", "GALA", "OPENING NIGHT", "AWARDS", "CEREMONY", "AFTERPARTY", "VIP",
  // Media Terms
  "HEADLINE", "TABLOID", "PAPARAZZI", "SCANDAL", "GOSSIP", "RUMOR", "EXCLUSIVE", "INTERVIEW", "REVIEW", "CRITIC",
  "RATING", "CHART", "BILLBOARD", "BESTSELLER", "FRANCHISE", "REBOOT", "SPINOFF", "CROSSOVER", "PARODY", "SATIRE",
];

export const POP_CULTURE_SEMANTIC_FAMILIES: string[][] = [
  ["GUITAR", "DRUMS", "BASS", "ALBUM", "CONCERT", "STAGE", "RHYTHM", "MELODY", "CHORUS", "LYRIC", "DJ", "KARAOKE"],
  ["DIRECTOR", "ACTOR", "SCENE", "SCRIPT", "TRAILER", "DOCUMENTARY", "ANIMATION", "SITCOM", "EMMY", "OSCAR", "CAMEO", "MONTAGE"],
  ["HERO", "VILLAIN", "SIDEKICK", "MENTOR", "REBEL", "DETECTIVE", "SAMURAI", "WIZARD", "CHAMPION", "LEGEND"],
  ["CONSOLE", "CONTROLLER", "ARCADE", "AVATAR", "QUEST", "BOSS", "LEVEL", "CHECKPOINT", "RESPAWN", "LOOT", "PATCH", "DLC"],
  ["MEME", "VIRAL", "TRENDING", "HASHTAG", "SELFIE", "STREAM", "PODCAST", "VLOG", "INFLUENCER", "FOLLOWER", "COMMENT", "SUBSCRIBE", "PROFILE"],
  ["RUNWAY", "MODEL", "DESIGNER", "VINTAGE", "RETRO", "PUNK", "GOTH", "SNEAKER", "HOODIE", "SUNGLASSES", "MAKEUP", "ACCESSORY"],
  ["HEADLINE", "TABLOID", "PAPARAZZI", "SCANDAL", "GOSSIP", "RUMOR", "INTERVIEW", "REVIEW", "CRITIC", "RATING", "BESTSELLER", "FRANCHISE", "REBOOT", "SPINOFF"],
  ["FESTIVAL", "CARNIVAL", "PARADE", "RAVE", "GALA", "AWARDS", "CEREMONY", "AFTERPARTY", "VIP"],
];

export const POP_CULTURE_PACK: WordPackDefinition = {
  key: "popculture",
  words: POP_CULTURE_WORDS,
  semanticFamilies: POP_CULTURE_SEMANTIC_FAMILIES,
};
